import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '../shared/primeng.module';
import { MaterialModuleModule } from '../material-module/material-module/material-module.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { bookDemoRouting } from './book-demo-routing.module';
import { BookADemoComponent } from '../book-a-demo/book-a-demo.component';
import { BookDemoComponent } from '../book-demo/book-demo.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PickASlotComponent } from '../shared/pick-a-slot/pick-a-slot.component';



@NgModule({
  declarations: [
    BookADemoComponent,
    BookDemoComponent,
    PickASlotComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    PrimengModule,
    MaterialModuleModule,
    MatTooltipModule,
    MatTabsModule,
    bookDemoRouting,
    BreadcrumbModule
  ],
  exports:[
    BookDemoComponent
  ]
})
export class BookingDemoModule { }
